import axios from 'axios';
import router from '../router'
import Vue from 'vue'


var imgServerUrl = process.env.IMG_BASE_URL;
axios.defaults.baseURL = process.env.API_URL;


axios.interceptors.request.use(function (config) {
    var ls = window.sessionStorage.getItem('jwt-token');
    config.headers['Jwt-Token'] = ls;
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    if (response.data.Code === 403) {

        if (response.request.responseURL.indexOf('Common/RoleOption') < 0) {
            Vue.prototype.$message.error(response.data.Msg);
        }


        router.replace({
            path: 'login',
            query: { redirect: router.currentRoute.fullPath }
        })
    } else if (response.data.Code !== 1) {
        Vue.prototype.$message.error(response.data.Msg);
    }

    return response;
}, function (error) {
    return Promise.reject(error);
});

export const getBaseUrl = params => {
    return axios.defaults.baseURL;
};

export const imgServerHost = params => {
    return imgServerUrl;
};

export const requestLogin = params => {
    var result = axios.post(`/api/Auth/SignIn`, params);
    return result;
};

export const editPassword = params => {
    var result = axios.post(`/api/Auth/EditPassword`, params);
    return result;
};

export const getUserDictOption = params => {
    var result = axios.get(`/api/Common/UserDictOption?key=` + params, {});
    return result;
};

export const getUsers = params => {
    var result = axios.post(`/api/User/Users`, params);
    return result;
};

export const exportUsersMainInfo = params => {
    var result = axios.post(`/api/User/ExportUsersMainInfo`, params);
    return result;
};

export const UserTagsExport = params => {
    var result = axios.post(`/api/User/UserTagsExport`, params);
    return result;
};

export const ImportUsers = params => {
    var result = axios.post('/api/User/ImportUsers', params);
    return result;
}

export const ImportUsersNew = params => {
    var result = axios.post('/api/User/ImportUsersNew', params);
    return result;
}

export const getProducts = params => {
    var result = axios.post(`/api/Product/Products`, params);
    return result;
};

export const productTree = params => {
    var result = axios.post(`/api/Product/ProductTree`, params);
    return result;
};

export const getCustomers = params => {
    var result = axios.post(`/api/Customer/Customers`, params);
    return result;
};

export const authCustomers = params => {
    var result = axios.post(`/api/Customer/AuthCustomer`, params);
    return result;
};

export const exportCustomerMainInfo = params => {
    var result = axios.post(`/api/Customer/ExportCustomerMainInfo`, params);
    return result;
};

export const exportNoVisitCustomerInfo = params => {
    var result = axios.post(`/api/Customer/ExportNoVisitCustomerInfo`, params);
    return result;
};

export const getEditedCustomers = params => {
    var result = axios.post(`/api/Customer/EditedCustomers`, params);
    return result;
};

export const downLoadCustomerTemplate = params => {
    var result = axios.post(`/api/Customer/DownLoadCustomerTemplate`, params);
    return result;
};

export const getRoleOption = params => {
    var result = axios.get(`/api/Common/RoleOption?addAll=` + params, {});
    return result;
};

export const getDomainOption = params => {
    var result = axios.get(`/api/Common/DomainOption?addAll=` + params, {});
    return result;
};

export const getUserRegionCascaderOption = params => {
    var result = axios.get(`/api/Common/AllUserRegionCascaderOption?pid=` + params, {});
    return result;
};

export const getRegionCascaderOption = params => {
    var result = axios.get(`/api/Common/AllRegionCascaderOption?pid=` + params, {});
    return result;
};

export const getUserCascaderOption = params => {
    if (params == null) params = false;
    var result = axios.get(`/api/Common/AllUserCascaderOption?pid=null&addAll=` + params, {});
    return result;
};

export const getUserMultiCascaderOption = params => {
    if (params == null) params = false;
    var result = axios.get(`/api/Common/AllUserMultiCascaderOption?pid=null&addAll=` + params, {});
    return result;
};

export const getTemplateIdOption = params => {
    if (params == null) params = false;
    var result = axios.get(`/api/Common/TemplateIdOption`, {});
    return result;
};

export const unBindLock = params => {
    var result = axios.post(`/api/User/UnBindLock?userId=` + params, {});
    return result;
};

export const resetAvatar = params => {
    var result = axios.post(`/api/User/ResetAvatar?userId=` + params, {});
    return result;
};

export const unBindIEMI = params => {
    var result = axios.post(`/api/User/UnBindIEMI?userId=` + params, {});
    return result;
};

export const resetPssword = params => {
    var result = axios.post(`/api/User/ResetPssword`, { UserId: params });
    return result;
};

export const editUser = params => {
    var result = axios.post(`/api/User/CreateOrUpdate`, params);
    return result;
};

export const exportUsers = params => {
    var result = axios.get(`/api/User/ExportUsers`, params);
    return result;
};

export const chainstoreOption = params => {
    var result = axios.get(`/api/Common/ChainstoreOption`, params);
    return result;
};
//主数据下拉列表接口集合
export const subChannelOption = params => {
    var result = axios.get(`/api/Common/ChannelOption`, params);
    return result;
};

export const subChannelOptionaddAll = params => {
    var result = axios.get(`/api/Common/ChannelOption?addAll=true`, params);
    return result;
};

export const subLv1ChannelOption = params => {
    var result = axios.get(`/api/Common/Lv1ChannelOption`, params);
    return result;
};

export const subLv2ChannelOption = params => {
    var result = axios.post(`/api/Common/Lv2ChannelOption`, params);
    return result;
};

export const subLv1TaskOption = params => {
    var result = axios.get(`/api/Common/Lv1TaskOption`, params);
    return result;
};

export const subLv2TaskOption = params => {
    var result = axios.post(`/api/Common/Lv2TaskOption`, params);
    return result;
};
export const subCityOption = params => {
    var result = axios.post(`/api/Common/CityOption`, params);
    return result;
};
export const subRegionOption = params => {
    var result = axios.post(`/api/Common/RegionOption`, params);
    return result;
};
export const subRegionLv2Option = params => {
    var result = axios.post(`/api/Common/Lv2RegionOption`, params);
    return result;
};
export const GetDictValue = params => {
    var result = axios.post(`/api/Common/GetDictValue`, params);
    return result;
};

export const getDistriburtors = params => {
    var result = axios.post(`/api/Distributor/GetDistriburtors`, params);
    return result;
};

export const GetDictChain = params => {
    var result = axios.post(`/api/Customer/GetDictChain`, params);
    return result;
};

export const GetDictChainLv2 = params => {
    var result = axios.post(`/api/Customer/GetDictChainLv2`, params);
    return result;
};
//门店审批接口集合

export const deleteCustomerApply = params => {
    var result = axios.post(`/api/Customer/DeleteCustomerApply`, params);
    return result;
};

export const jobtaskOption = params => {
    var result = axios.get(`/api/Common/JobTaskOption`, params);
    return result;
};
export const templateOption = params => {
    //var result = axios.get(`/api/Common/TemplateOption`, params);
    var result = axios.post(`/api/Common/TemplateOption`, params);
    return result;
};

export const importCustomers = params => {
    var result = axios.post(`/api/Customer/ImportCustomer`, params);
    return result;
};

export const getManagerCallReport = params => {
    var result = axios.post(`/api/NCallCard/GetManagerCallReport`, params);
    return result;
};

export const getCallCardPhoto = params => {
    var result = axios.post(`/api/CallCard/GetCallCardPhoto`, params);
    return result;
};

export const getCallCardPhotoRar = params => {
    var result = axios.post(`/api/CallCard/GetCallCardPhotoRar`, params);
    return result;
};

export const getCallCardPhotoExcel = params => {
    var result = axios.post(`/api/CallCard/GetCallCardPhotoExcel`, params);
    return result;
};

export const getCallCardDetail = params => {
    var result = axios.post(`/api/NCallCard/GetCallCardDetail`, params);
    return result;
};

export const getCallCardDetails = params => {
    var result = axios.post(`/api/NCallCard/GetDetailWithValues?callCardId=` + params.CallCardID + '&brand=' + params.Brand, {});
    return result;
};

export const getRoutePlanDetails = params => {
    var result = axios.post(`/api/NRoutePlan/GetRoutePlanDetails?userId=` + params.userId + '&month=' + params.month, {});
    return result;
};

export const importProducts = params => {
    var result = axios.post(`/api/Product/ImportProducts`, params);
    return result;
};

export const message = params => {
    var result = axios.post(`/api/NMessage/Message`, params);
    return result;
};

export const messageSend = params => {
    var result = axios.post(`/api/NMessage/Send`, params);
    return result;
};

export const getMessageList = params => {
    var result = axios.get(`/api/NMessage/GetMessageList?pageSize=` + params.pageSize + '&page=' + params.page + '&uid=' + params.uid + '&group=' + params.group, {});
    return result;
};

export const getMessageDetail = params => {
    var result = axios.get(`/api/NMessage/GetMessageDetail?pid=` + params.pid + '&uid=' + params.uid, {});
    return result;
};

export const getMessagebackDetail = params => {
    var result = axios.get(`/api/NMessage/GetMessageBackDetail?callCardId=` + params.CallCardId + '&userId=' + params.UserId, {});
    return result;
};

export const SendReply = (params, distUserId) => {
    var result = axios.post(`/api/NMessage/SendReply?userId=` + distUserId + '&msgId=' + params.MsgId + "&txt=" + params.Txt, {});
    return result;
};

export const SearchAtomConfig = (params) => {
    var result = axios.post(`/api/ConfigCenter/SearchAtomConfig`, params);
    return result;
};

export const DelAtomConfig = (param) => {
    var result = axios.post(`/api/ConfigCenter/DelAtomConfig` + `?configId=` + param, null);
    return result;
};


export const SearchWorkRole = (params) => {
    var result = axios.post(`/api/ConfigCenter/SearchWorkRole`, params);
    return result;
};

export const AddWorkRole = (params) => {
    var result = axios.post(`/api/ConfigCenter/AddWorkRole`, params);
    return result;
};

export const EditWorkRole = (params) => {
    var result = axios.post(`/api/ConfigCenter/EditWorkRole`, params);
    return result;
};

export const DelWorkRole = (param) => {
    var result = axios.post(`/api/ConfigCenter/DelWorkRole` + `?wid=` + param, null);
    return result;
};

export const SearchPermission = (params) => {
    var result = axios.post(`/api/ConfigCenter/SearchPermission`, params);
    return result;
};

export const AddPermission = (params) => {
    var result = axios.post(`/api/ConfigCenter/AddPermission`, params);
    return result;
};

export const EditPermission = (params) => {
    var result = axios.post(`/api/ConfigCenter/EditPermission`, params);
    return result;
};

export const DelPermission = (param) => {
    var result = axios.post(`/api/ConfigCenter/DelPermission` + `?pid=` + param, null);
    return result;
};

export const AddAtomConfig = (params) => {
    var result = axios.post(`/api/ConfigCenter/AddAtomConfig`, params);
    return result;
};

export const EditAtomConfig = (params) => {
    var result = axios.post(`/api/ConfigCenter/EditAtomConfig`, params);
    return result;
};


export const SearchDict = (params) => {
    var result = axios.post(`/api/ConfigCenter/SearchDict`, params);
    return result;
};

export const AddDict = (params) => {
    var result = axios.post(`/api/ConfigCenter/AddDict`, params);
    return result;
};

export const EditDict = (params) => {
    var result = axios.post(`/api/ConfigCenter/EditDict`, params);
    return result;
};

export const DelDict = (param) => {
    var result = axios.post(`/api/ConfigCenter/DelDict` + `?cid=` + param, null);
    return result;
};

export const SetRolePermissions = (params) => {
    var result = axios.post(`/api/ConfigCenter/SetRolePermissions`, params);
    return result;
};

export const GetAppVersion = (params) => {
    var result = axios.get(`/api/ConfigCenter/GetAppVersion?domainId=${params}`);
    return result;
};

export const DeployAndroid = (params) => {
    var result = axios.post(`/api/ConfigCenter/DeployAndroid`, params);
    return result;
};

export const DeployIos = (params) => {
    var result = axios.post(`/api/ConfigCenter/DeployIos`, params);
    return result;
};

export const CityTree = (params) => {
    var result = axios.post(`/api/CityRegion/CityTree`, params);
    return result;
};

export const Cities = (params) => {
    var result = axios.post(`/api/CityRegion/Cities`, params);
    return result;
};
export const ExportCities = (params) => {
    var result = axios.post(`/api/CityRegion/ExportCities`, params);
    return result;
};

export const RegionTree = (params) => {
    var result = axios.post(`/api/CityRegion/RegionTree`, params);
    return result;
};

export const Regions = (params) => {
    var result = axios.post(`/api/CityRegion/Regions`, params);
    return result;
};
export const ExportRegions = (params) => {
    var result = axios.post(`/api/CityRegion/ExportRegions`, params);
    return result;
};


export const AddRegion = (params) => {
    var result = axios.post(`/api/CityRegion/AddRegion`, params);
    return result;
};

export const EditRegion = (params) => {
    var result = axios.post(`/api/CityRegion/EditRegion`, params);
    return result;
};

export const DelRegion = (param) => {
    var result = axios.post(`/api/CityRegion/DelRegion` + `?rid=` + param, null);
    return result;
};


export const AddCity = (params) => {
    var result = axios.post(`/api/CityRegion/AddCity`, params);
    return result;
};

export const EditCity = (params) => {
    var result = axios.post(`/api/CityRegion/EditCity`, params);
    return result;
};

export const DelCity = (param) => {
    var result = axios.post(`/api/CityRegion/DelCity` + `?rid=` + param, null);
    return result;
};

export const getChannels = params => {
    var result = axios.post(`/api/Channel/Channels`, params);
    return result;
};

export const importChannels = params => {
    var result = axios.post(`/api/Channel/ImportChannel`, params);
    return result;
};

export const getDistributors = params => {
    var result = axios.post(`/api/Distributor/Distributors`, params);
    return result;
};

export const importDistributors = params => {
    var result = axios.post(`/api/Distributor/ImportDistributor`, params);
    return result;
};

export const getCbds = params => {
    var result = axios.post(`/api/Cbd/Cbds`, params);
    return result;
};

export const importCbds = params => {
    var result = axios.post(`/api/Cbd/ImportCbd`, params);
    return result;
};

export const jobTasks = params => {
    var result = axios.post(`/api/JobTask/JobTasks`, params);
    return result;
};

export const JobTasksForUser = params => {
    var result = axios.post(`/api/JobTask/JobTasksForUser`, params);
    return result;
};

export const taskTypeOption = params => {
    var result = axios.post(`/api/Common/TaskTypeOption`, params);
    return result;
};

export const taskGroupOption = params => {
    var result = axios.post(`/api/Common/TaskGroupOption`, params);
    return result;
};

export const CreateTask = params => {
    var result = axios.post(`/api/JobTask/CreateTask`, params);
    return result;
};

export const DeployTask = params => {
    var result = axios.post(`/api/JobTask/DeployTask`, params);
    return result;
};


export const ChannelTree = params => {
    var result = axios.post(`/api/Channel/ChannelTree`, params);
    return result;
};

export const ImportRegions = params => {
    var result = axios.post(`/api/CityRegion/ImportRegions`, params);
    return result;
};


export const ProductTags = params => {
    var result = axios.post(`/api/Product/ProductTags`, params);
    return result;
};


export const ProductsFromTags = params => {
    var result = axios.post(`/api/Product/ProductsFromTags`, params);
    return result;
};

export const GetDictsByParentCode = params => {
    var result = axios.post(`/api/Common/GetDictsByParentCode?dictCode=` + params, {});
    return result;
};

export const GetDictsByDomainParentCode = params => {
    var result = axios.post(`/api/Common/GetDictsByDomainParentCode?dictCode=` + params, {});
    return result;
};



export const GetChannelByIds = params => {
    var result = axios.post(`/api/Common/GetChannelByIds?channelIds=` + params, {});
    return result;
};

export const GetDictsByParentCodeAsync = async params => {
    var result = await axios.post(`/api/Common/GetDictsByParentCode?dictCode=` + params, {});
    return result;
};

export const AddTaskDicts = params => {
    var result = axios.post(`/api/ConfigCenter/AddTaskDicts`, params);
    return result;
};

export const getReport1 = params => {
    var result = axios.post(`/api/Report/GetReport1`, params);
    return result;
};
export const getReportList = params => {
    var result = axios.post(`/api/Report/getReportList`, params);
    return result;
};

export const GetWorkLoadReport = params => {
    var result = axios.post(`/api/Report/GetWorkLoadReport`, params);
    return result;
};
export const GetPerformanceReport = params => {
    var result = axios.post(`/api/Report/GetPerformanceReport`, params);
    return result;
};

export const GetToTerminalReport = params => {
    var result = axios.post(`/api/Report/GetToTerminalReport`, params);
    return result;
};
export const GetToTerminalReport_KPI = params => {
    var result = axios.post(`/api/Report/GetToTerminalReport_KPI`, params);
    return result;
};

export const getKPIRegionCascaderOption = params => {
    var result = axios.get(`/api/Report/AllRegionCascaderOption?domainId=` + params, {});
    return result;
};
export const getUserCascaderReport = params => {
    if (params == null) params = false;
    var result = axios.get(`/api/Report/AllUserCascaderOption?userId=` + params, {});
    return result;
};
export const getKPIRoleOption = params => {
    var result = axios.get(`/api/Report/RoleOption?domainId=` + params, {});
    return result;
};

export const getKPIChannelOption = params => {
    var result = axios.get(`/api/Report/Lv1ChannelOption?domainId=` + params, {});
    return result;
};

export const getWorkRoleByUser = params => {
    var result = axios.get(`/api/Report/GetWorkRoleByUser?userId=` + params, {});
    return result;
};

export const GetTableColumns = params => {
    var result = axios.post(`/api/Common/GetTableColumns?tableName=` + params, {});
    return result;
};

export const SetTaskStatus = params => {
    var result = axios.post(`/api/JobTask/SetTaskStatus`, params);
    return result;
};

export const CopyTask = params => {
    var result = axios.post(`/api/JobTask/CopyTask?taskId=${params.taskId}&newName=${params.newName}`, {});
    return result;
};


export const GetTaskById = params => {
    var result = axios.post(`/api/JobTask/GetTaskById?taskId=` + params, {});
    return result;
};

export const GetTempletes = params => {
    var result = axios.post(`/api/JobTask/GetTempletes?taskId=` + params, {});
    return result;
};

export const SetTaskSort = params => {
    var result = axios.post(`/api/JobTask/SetSort?taskId=` + params, {});
    return result;
};

export const CoverTaskSetting = params => {
    var result = axios.post(`/api/JobTask/CoverTaskSetting?fromTaskId=${params.fromTaskId}&toTaskId=${params.toTaskId}`, {});
    return result;
};

export const DelSkuOrTypes = params => {
    var result = axios.post(`/api/Product/DelSkuOrTypes?pid=${params.pid}&isSku=${params.isSku}`, {});
    return result;
};

export const Domains = params => {
    var result = axios.post(`/api/Domain/Domains`, {});
    return result;
};

export const SetSortByGroup = params => {
    var result = axios.post(`/api/JobTask/SetSortByGroup?taskIds=` + params, {});
    return result;
};

//门店审核接口集合
export const ExportCustomerInfo = params => {
    var result = axios.post(`/api/Customer/ExportCustomerInfo`, params);
    return result;
};

export const GetCallCardBase = params => {
    var result = axios.post(`/api/CallCard/GetCallCardBase?callCardId=${params}`);
    return result;
};

export const GetCallCardModule = params => {
    var result = axios.post(`/api/CallCard/GetCallCardModule?taskId=${params.taskId}&&templateId=${params.templateId}&&callCardId=${params.callCardId}&&itemType=${params.itemType}`);
    return result;
};

export const AddDomain = params => {
    var result = axios.post(`/api/Domain/AddDomain`, params);
    return result;
};


export const GetTaskTags = params => {
    var result = axios.post(`/api/JobTask/GetTaskTags?taskId=${params.JobTaskId}` );
    return result;
};

export const SetTaskTags = params => {
    var result = axios.post(`/api/JobTask/SetTaskTags`,params );
    return result;
};

export const GetAllTaskTags = params => {
    var result = axios.post(`/api/JobTask/GetAllTaskTags`,params );
    return result;
};
export const GetAllTaskGroups = params => {
    var result = axios.post(`/api/JobTask/GetAllTaskGroups`,params );
    return result;
};
export const DelTaskTag = params => {
    var result = axios.post(`/api/JobTask/DelTaskTag?taskTagName=${params}` );
    return result;
};

export const GetTaskNames = params => {
    var result = axios.get(`/api/JobTask/GetTaskNames` );
    return result;
};

export const GetTaskNamesByTags = params => {
    var result = axios.post(`/api/JobTask/GetTaskNamesByTags` ,params);
    return result;
};
export const GetTaskNamesByGroupIds = params => {
    var result = axios.post(`/api/JobTask/GetTaskNamesByGroupIds` ,params);
    return result;
};

export const GetTaskModules = params => {
    var result = axios.get(`/api/JobTask/GetTaskModules?taskId=${params}` );
    return result;
};

export const GetCopyTaskModulesJson = params => {
    var result = axios.post(`/api/JobTask/GetCopyTaskModulesJson`,params );
    return result;
};

export const GenHtmlFileFromJson = params => {
    var result = axios.post(`/api/JobTask/GenHtmlFileFromJson`,params );
    return result;
};

export const GetPromoteModules = params => {
    var result = axios.post(`/api/JobTask/GetPromoteModules?taskId=${params}`);
    return result;
};

export const AddPromote = params => {
    var result = axios.post(`/api/Promote/AddPromote`,params );
    return result;
};

export const Promotes = params => {
    var result = axios.post(`/api/Promote/Promotes`,params );
    return result;
};

export const PromotesExport = params => {
    var result = axios.post(`/api/Promote/PromotesExport`,params );
    return result;
};

export const GetPromoteTemplateItems = params => {
    var result = axios.post(`/api/JobTask/GetPromoteTemplateItems?templateId=${params}` );
    return result;
};

export const GetLogList = params => {
    var result = axios.post(`/api/Common/GetLogList` ,params);
    return result;
};

export const DownLoadUserInErr = params => {
    var result = axios.post(`/api/User/DownLoadUserInErr?batchId=${params}` );
    return result;
};

export const DelPromote = params => {
    var result = axios.post(`/api/Promote/DelPromote?promoteId=${params}` );
    return result;
};

export const IsHideImportDel = params => {
    var result = axios.post(`/api/JobTask/IsHideImportDel?taskId=${params}` );
    return result;
};

export const DownLoadUserTagInErr = params => {
    var result = axios.post(`/api/User/DownLoadUserTagInErr?batchId=${params}` );
    return result;
};

export const UserTagOption = params => {
    var result = axios.post(`/api/User/UserTagOption` );
    return result;
};

export const GetBLogs = params => {
    var result = axios.post(`/api/JobTask/GetBLogs?taskId=${params}` );
    return result;
};

export const GetCustomerKpi = params => {
    var result = axios.post(`/api/Customer/GetCustomerKpi`,params );
    return result;
};

export const UserMultiSelectOption = params => {
    var result = axios.post(`/api/Common/UserMultiSelectOption?keyWord=${params}`);
    return result;
};

export const DelChannel = params => {
    var result = axios.post(`/api/Channel/DelChannel?channelId=${params}`);
    return result;
};

export const ExportTaskCustomers = params => {
    var result = axios.post(`/api/Customer/ExportTaskCustomers?taskId=${params}`);
    return result;
};

export const ExportTaskUsers = params => {
    var result = axios.post(`/api/User/ExportTaskUsers?taskId=${params}`);
    return result;
};

export const ImportTargetMarkets = params => {
    var result = axios.post(`/api/TaskTarget/ImportTaskTarget`, params);
    return result;
};

export const ExportTaskResult = params => {
    var result = axios.get(`/api/JobTask/ExportTaskResult?userid=${params.UserId}&taskId=${params.taskId}&sdate=${params.StartDate}
    &edate=${params.EndDate}&regionIds=${params.RegionIds}&moduleIds=${params.ModuleIds}&isToday=${params.isToday}`);
    return result;
};

export const ImportPianQuMarkets = params => {
    var result = axios.post(`/api/TaskTarget/ImportPianQuTarget`, params);
    return result;
};

export const GetCallCardDetailPhotoRar = params => {
    var result = axios.post(`/api/CallCard/GetCallCardDetailPhotoRar?callCardId=${params}`);
    return result;
};

export const GetCustomerPhotoAuthList = params => {
    var result = axios.post(`/api/Customer/GetCustomerPhotoAuthList`,params);
    return result;
};

export const AuthGetCustomerPhoto = params => {
    var result = axios.post(`/api/Customer/AuthGetCustomerPhoto`,params);
    return result;
};
//中间件导入导出下载
export const ImportInterLibrary = params => {
    var result = axios.post(`/api/Schedule/ImportInterLibrary`,params);
    return result; 
};
export const DownLoadInterLibraryErrFiles = params => {
    var result = axios.post(`/api/Schedule/DownLoadInterLibraryErrFiles?batchId=${params}`);
    return result; 
};
export const DownLoadInterLibraryFiles = params => {
    var result = axios.post(`/api/Schedule/DownLoadInterLibraryFiles?TaskId=${params}`);
    return result; 
};







// WEBPACK FOOTER //
// ./src/api/api.js